import React from 'react';
import { useRefCallback } from '@okee-uikit/react-hooks';
import { useDisplayInfo, useOptionUpdate, useSelect } from '../../../hooks/select';
import { SelectPopoverPanel } from '../components/SelectPopoverPanel';
export function useSelectPopper(options) {
  var show = options.show,
      _options$searchable = options.searchable,
      searchable = _options$searchable === void 0 ? false : _options$searchable,
      autoAlign = options.autoAlign,
      autoFocusSearch = options.autoFocusSearch,
      popoverWidth = options.popoverWidth,
      children = options.children,
      emptyRender = options.emptyRender,
      emptyContent = options.emptyContent,
      triggerId = options.triggerId,
      onSearchChange = options.onSearchChange,
      searchPlaceholder = options.searchPlaceholder,
      renderFooter = options.renderFooter;
  var select = useSelect();
  var searchChange = useRefCallback(onSearchChange);
  var extraProps = select.getExtraProps();
  var size = extraProps.size || 'md';
  var clearable = extraProps.clearable || false;

  var _useDisplayInfo = useDisplayInfo(children),
      displayInfo = _useDisplayInfo.displayInfo,
      allDisplayInfo = _useDisplayInfo.allDisplayInfo;

  useOptionUpdate();

  var getPopover = function getPopover() {
    return React.createElement(SelectPopoverPanel, {
      autoAlign: autoAlign,
      autoFocusSearch: autoFocusSearch,
      popoverWidth: popoverWidth,
      triggerId: triggerId,
      searchable: searchable,
      emptyRender: emptyRender,
      emptyContent: emptyContent,
      onSearchChange: searchChange,
      show: show,
      searchPlaceholder: searchPlaceholder,
      renderFooter: renderFooter
    }, children);
  };

  return {
    getPopover: getPopover,
    displayInfo: displayInfo,
    allDisplayInfo: allDisplayInfo,
    size: size,
    clearable: clearable
  };
}